(function($, document, window, undefined) {
  window.IPRedirect = {
    init: function(settings) {
      var self = IPRedirect;

      self.settings = settings;

      self.force_redirect = settings['redirect_force'] ? true : false;
      self.relative_redirect = settings['redirect_relative'] ? true : false;

      self.messageWrap = $('#location-redirect-message');
      self.currentCountry = $('.current-country', self.messageWrap);
      self.newStore = $('.new-store', self.messageWrap);
      self.RedirectMe = $('.redirect-me', self.messageWrap);
      self.closeBtn = $('.close-redirect-btn', self.messageWrap);

      self.eu_country_codes = ['AX', 'AL', 'AD', 'AM', 'AT', 'BY', 'BE', 'BA', 'BV', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'GE', 'DE', 'GI', 'GR', 'GL', 'GP', 'GG', 'HU', 'IS', 'IE', 'IM', 'IT', 'JE', 'XK', 'LV', 'LI', 'LT', 'LU', 'MT', 'YT', 'MD', 'MC', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT', 'RE', 'RO', 'SM', 'RS', 'SK', 'SI', 'ES', 'SJ', 'SE', 'CH', 'TR', 'UA', 'GB', 'VA'];

      if (!sessionStorage.getItem('location-redirect')) {
        self.fetchLocationInfo();
      } else {
        self.location = JSON.parse(sessionStorage.getItem('location-redirect'));
        self.processLocationInfo();
      }
    },
    fetchLocationInfo: function() {
      var self = IPRedirect;
      $.ajax( {
        url: 'https://server.shortcodesforshopify.com/json/?callback=?',
        type: 'POST',
        dataType: 'jsonp',
        async: false,
        success: self.fetchLocationInfoSuccessCallback,
        error: self.fetchLocationInfoErrorCallback
      });
    },
    fetchLocationInfoSuccessCallback: function(response) {
      var self = IPRedirect;
      self.location = {
        'country_code': response.country_code,
        'country_name': response.country_name,
        'redirect_cancelled': false
      };
      sessionStorage.setItem('location-redirect', JSON.stringify(self.location));
      self.processLocationInfo();
    },
    fetchLocationInfoErrorCallback: function(response) {
      var self = IPRedirect;
      self.location = {
        'country_code': '',
        'country_name': '',
        'redirect_cancelled': false
      };
      sessionStorage.setItem('location-redirect', JSON.stringify(self.location));
      self.processLocationInfo();
    },
    processLocationInfo: function() {
      var self = IPRedirect;
      self.handleHeaderMessage();
      if (!self.location['redirect_cancelled'] || self.force_redirect) {
        self.handleRedirect();
      }
      self.handleCurrencySelection();
    },
    handleHeaderMessage: function() {
      var self = IPRedirect;
      if (self.location.country_code == 'US' || self.location.country_code == 'CA' || self.location.country_code == 'MX') {
        $('.header #promo_banner').text('FREE SHIPPING TO USA + CANADA (YES FREE! READ THAT AGAIN!)');
      }
    },
    handleCurrencySelection: function() {
      var self = IPRedirect;
      
      var country_code = self.location.country_code;

      localStorage.setItem('lilyandfox-detected-country', country_code);

      if (localStorage.getItem('lilyandfox-detected-country') && !localStorage.getItem('lilyandfox-default-currency')) {

        var currency_code = 'USD';

        if (country_code == 'CA') {
          currency_code = 'CAD';
        } else if (country_code == 'GB') {
          currency_code = 'GBP';
        } else if (country_code == 'CH') {
          currency_code = 'CHF';
        } else if (self.eu_country_codes.indexOf(country_code) != -1) {
          currency_code = 'EUR';
        }

        localStorage.setItem('lilyandfox-default-currency', currency_code);

        // set currency
        var select = document.querySelector('select[name="currency"]');
        select.value = currency_code;
        select.form.submit();
      }
    },
    handleRedirect: function() {
      var self = IPRedirect;
      var country_name = '', store_name = '';

      if (self.location.country_code == 'AU') {
        country_name = "Are you in Australia?";
        store_name = 'Australian';
      } else if (self.location.country_code == 'GB') {
        country_name = "Are you in the UK?";
        store_name = 'UK';
      } else if (self.location.country_code == 'CH') {
        country_name = "Are you in Switzerland?";
        store_name = 'Swiss';
      } else if (self.eu_country_codes.indexOf(self.location.country_code) != -1) {
        country_name = "Are you in Europe?";
        store_name = 'European';
      } else if (self.location.country_code != 'US' && self.location.country_code != 'CA' && self.location.country_code != 'MX') {
        country_name = "Not in North America?";
        store_name = 'International';
      }

      if (country_name != '' && country_name != '') {
        var url = 'https://lilyandfox.com.au' + (self.relative_redirect ? window.top.location.pathname : '');
        if (window.top.location.search.indexOf('gclid') != -1) {
          // pass gclid through to other store when present in query params
          url += '?' + window.top.location.search.match(/gclid=[^&]+/)[0];
        }
        if (self.force_redirect) {
          window.top.location.assign(url);
        } else {
          self.currentCountry.text(country_name);
          self.newStore.text(store_name);
          self.RedirectMe.attr("href", url);
          self.RedirectMe.on("click", function(e) {
            e.stopPropagation();
          });
          self.closeBtn.on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            self.messageWrap.hide();
            self.location.redirect_cancelled = true;
            sessionStorage.setItem('location-redirect', JSON.stringify(self.location));
            // restore the original 'bottom' style of the fomo-popup
            document.body.removeChild(self.someonePurchasedStyle);
          });
          self.messageWrap.show();
          // set the 'bottom' style of the fomo-popup to show above redirect-message
          var redirect_height = $('#location-redirect-message').innerHeight();
          var fomo_popup_bottom_new = parseFloat(redirect_height) + 5;
          var style = document.createElement('style');
          style.type = 'text/css';
          style.appendChild(document.createTextNode('#someone-purchased { bottom: ' + fomo_popup_bottom_new + 'px; }'));
          document.body.appendChild(style);
          self.someonePurchasedStyle = style;
        }
      }
    }
  };
})(jQuery, document, window);
